export default __webpack_public_path__ + "static/media/travelly.f0be14e0.jpg";